import { DateForm } from 'hooks/commons/useSearchFilterForm';
import _cloneDeep from 'lodash/cloneDeep';
import { SearchDateRangeFilterProps } from 'types/common/searchfilter';

export const getDateForm = (searchParams: SearchDateRangeFilterProps): DateForm => {
  return _cloneDeep({
    dateInterval: [searchParams.dateFrom, searchParams.dateTo],
    dateTerm: searchParams.dateTerm,
  });
};
